export const URL_API = {
  AUTH: {
    LOGIN: "v1/authenticate/login",
    GET_ME: "v1/me",
  },
  TRANSACTIONS: {
    GET_LIST: "/v1/transactions",
    GET_DETAIL: "/v1/transactions/",
    DELETE: "/v1/transactions/",
    CHARGE_USER: "/v1/transactions/charge-user",
  },
  CHARGE_SESSIONS: {
    BASE: "/v1/charge-sessions",
    GET_LIST: "/v1/charge-sessions",
    STATISTICS_BY_LOCATION: "/v1/charge-sessions/statistics",
    GET_DETAIL: "/v1/charge-sessions/",
    UPDATE: "",
    DELETE: "",
    GET_SETTLE_ENERGY: "/v1/charge-sessions/",
  },
  LOCATION: {
    GET_LIST: "/v1/locations",
    CREATE: "v1/locations",
    GET_DETAIL: "/v1/locations/",
    UPDATE: "/v1/locations/",
    DELETE: "/v1/locations/",
    ENABLE_SUBSCRIPTION_PLAN: "/v1/locations/",
    STATISTICS_BY_ADMIN: "/v1/locations/statistics",
  },
  PROMO_CODE: {
    GET_LIST: "/v1/promo-codes",
    GET_DETAIL: "/v1/promo-codes/",
    CREATE: "/v1/promo-codes/",
    UPDATE: "/v1/promo-codes/",
    DELETE: "/v1/promo-codes/",
    CALCULATE: "/v1/promo-codes/",
    INVALIDATE: "/v1/promo-codes/",
  },
  PROMO_PROGRAM: {
    GET_LIST: "/v1/promo-programs",
    GET_DETAIL: "/v1/promo-programs/",
    UPDATE: "/v1/promo-programs/",
    DELETE: "/v1/promo-programs/",
    CREATE: "/v1/promo-programs/",
  },
  SUBSCRIPTION_PLANS: {
    GET_LIST: "/v1/subscription-plans",
    GET_DETAIL: "/v1/subscription-plans/",
    CREATE: "/v1/subscription-plans",
    CREATE_SUBSCRIBE: "/v1/subscription-plans/subscribe",
    GENERATE_ACTIVATION_CODE:
      "/v1/subscription-plans/generate-activation-codes",
    UPDATE: "/v1/subscription-plans/",
    DELETE: "/v1/subscription-plans/",
  },
  SUBSCRIPTION: {
    GET_LIST: "/v1/subscriptions",
    ACTIVE: "/v1/subscriptions",
    CREATE_PAYMENT: "/v1/subscriptions",
    DE_ACTIVE: "/v1/subscriptions",
    DELETE: "/v1/subscriptions/",
    GET_LOCATIONS: "/v1/subscriptions/location",
    UPDATE_INFORMATION: "/v1/subscriptions/infor/",
  },
  USER: {
    CREATE: "v1/users/",
    GET_LIST: "/v1/users",
    GET_LIST_RESTRICTED: "/v1/users/restricted-users",
    UPDATE: "v1/users/",
    DETAIL: "v1/users/",
    TOP_UP: "v1/users/top-up-free-credits",
    DELETE: "v1/users/",
    RESTORE: "v1/users/restore/",
  },
  TOKENIZED_CARD: {
    GET_LIST: "/v1/tokenizedcards",
  },
  CHARGE_POINTS: {
    GET_LIST: "/v1/charge-points",
    GET_DETAIL: "/v1/charge-points/",
    UPDATE: "/v1/charge-points",
    DELETE: "/v1/charge-points",
    GET_LIST_RESTRICTED: "/v1/evses/restricted-users",
    ENABLE_SUBSCRIPTION_PLAN: "/v1/charge-points/",
    AMPECO_SYNC_EVSE: "/v1/charge-points/ampeco-sync-evse",
  },
  EVSES: {
    GET_LIST: "/v1/evses",
    TOP_UTILIZATION_RATING: "/v1/evses/top-utilization-rating",
    SYNC: "/v1/evses/sync",
    SYNC_ALL: "/v1/evses/ampeco/sync-all",
    STATISTICS_BY_ADMIN: "/v1/evses/statistics",
  },
  INFORMATION_CATEGORY: {
    GET_LIST: "/v1/information-categories",
    DELETE: "/v1/information-categories",
  },
  INFORMATION: {
    LIST: "/v1/information",
  },
  UPLOAD: "/v1/upload",
  QUEUING: {
    GET_LIST: "/v1/queue",
    LEAVE: "/v1/queue/cancel",
  },
  AUDIT_LOG: {
    GET_LIST: "/v1/audit-log",
    GET_LIST_BY_TYPE: "/v1/audit-log/logs/evse",
  },
  REWARDS_PROGRAMS: {
    GET_LIST: "/v1/reward-programs",
    GET_DETAIL: "/v1/reward-programs",
    CREATE: "/v1/reward-programs",
    UPDATE: "/v1/reward-programs/",
    DELETE: "/v1/reward-programs/",
  },
  REWARD_TYPES: {
    GET_LIST: "/v1/reward-types",
    GET_DETAIL: "/v1/reward-types",
    CREATE: "/v1/reward-types",
  },
  REWARD_CODES: {
    GET_LIST: "/v1/reward-codes",
    GET_DETAIL: "/v1/reward-codes",
    CREATE: "/v1/reward-codes",
    UPDATE: "/v1/reward-codes/",
    DELETE: "/v1/reward-codes/",
    IMPORT: "/v1/rewards/import",
  },
  REWARDS: {
    GET_LIST: "/v1/rewards",
    GET_DETAIL: "/v1/rewards",
    CREATE: "/v1/rewards",
    GET_POINTS_STATISTIC: "v1/point-histories/points-statistics",
  },
  PAYMENTS: {
    REFUND: "/v1/payments/refund-payment",
  },
  ADMIN: {
    GET_LIST: "/v1/admins",
    CREATE: "/v1/admins",
    DELETE: "/v1/admins/:id",
    EDIT: "/v1/admins/:id",
    PATCH: "/v1/admins/:id",
  },
  COMPANY: {
    GET_LIST: "/v1/companies",
    CREATE: "/v1/companies",
    DELETE: "/v1/companies/:id",
    EDIT: "/v1/companies/:id",
    PATCH: "/v1/companies/:id",
  },
  REWARD_CATEGORIES: {
    GET_LIST: "/v1/reward-categories",
    GET_DETAIL: "/v1/reward-categories",
    CREATE: "/v1/reward-categories",
    UPDATE: "/v1/reward-categories/",
    DELETE: "/v1/reward-categories/",
  },
  REWARD_VENDORS: {
    GET_LIST: "/v1/reward-vendors",
    GET_DETAIL: "/v1/reward-vendors",
    CREATE: "/v1/reward-vendors",
    UPDATE: "/v1/reward-vendors/",
    DELETE: "/v1/reward-vendors/",
  },
  REWARD_BANNERS: {
    GET_LIST: "/v1/reward-banners",
    GET_DETAIL: "/v1/reward-banners",
    CREATE: "/v1/reward-banners",
    UPDATE: "/v1/reward-banners/",
    DELETE: "/v1/reward-banners/",
  },
};
